import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";

export const StyledScaleBarInner = styled.div<{ $width: string | number }>`
  ${tw`tw-relative`}

  height: 3px;
  background: #37ba82;
  z-index: 1;

  ${(props) =>
    props.$width &&
    css`
      width: ${props.$width}%;
    `}
`;

export const StyledScaleBar = styled.div`
  ${tw`tw-w-full`}
  ${BoxSizingStyle}
`;

StyledScaleBar.displayName = "StyledScaleBar";
StyledScaleBarInner.displayName = "StyledScaleBarInner";
